import api from '../apis/ufrnApi'

export const itemService = itemId => {
    let url = `/acervos/${itemId}`
    return api.get(url)
}

export const itemExtrasService = query => {
    let url = `/detalhes-extras/${query}`
    return api.get(url)
}